const THREE = require('three')
import MovieClip from 'src/helpers/MovieClip' 
import TweenMax from 'gsap'
import Raf from 'src/helpers/Raf'


import EyeOneSpritesheet from '@/assets/sprites/one-eye'
import EyeTwoSpritesheet from '@/assets/sprites/two-eye'
import EyeThreeSpritesheet from '@/assets/sprites/three-eye'
import ButterflySpritesheet from '@/assets/sprites/butterfly'

  
class Eyes extends THREE.Group {

  constructor(config) {

    super();
   
    this.position.y = -750; 

    this.setup(); 
    this.resize() 
  } 

  setup() { 
 
    this.alieneyes_mesh = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.25, 2048 * 0.25), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/alien-eyes.png')),
        transparent: true
      })
    );  
    this.alieneyes_mesh.position.z = -500; 
    this.alieneyes_mesh.position.x = -50; 

    this.alieneyes_cloud_one = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(512 *0.4, 128 *0.4), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/alien-eyes_cloud1.png')),
        transparent: true
      })
    );   
    this.alieneyes_cloud_one.position.z = -700; 
    this.alieneyes_cloud_one.position.x = 400;
    this.alieneyes_cloud_one.position.y = 100;   

    this.alieneyes_cloud_two = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(256* 0.7, 128* 0.7), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/alien-eyes_cloud2.png')),
        transparent: true
      })
    );  
    this.alieneyes_cloud_two.position.z = -701; 
    this.alieneyes_cloud_two.position.x = -200;
    this.alieneyes_cloud_two.position.y = 100;  

    this.alieneyes_cloud_three = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(256 * 0.3, 128 * 0.3), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/alien-eyes_cloud3.png')),
        transparent: true
      })
    );  
    this.alieneyes_cloud_three.position.z = -800; 
    this.alieneyes_cloud_three.position.x = 50;
    this.alieneyes_cloud_three.position.y = -100;  

    this.add(this.alieneyes_mesh);
    this.add(this.alieneyes_cloud_one);
    this.add(this.alieneyes_cloud_two);
    this.add(this.alieneyes_cloud_three);

    this.createSprites();

    Raf.add(this.onTick)
  }

  createSprites() {


    this.oneeye_mc = new MovieClip({
      fps: 8,
      frames: EyeOneSpritesheet.frames,
      frame_width: 512,
      frame_height: 512,
      spritesheet_width: EyeOneSpritesheet.meta.size.w,
      spritesheet_height: EyeOneSpritesheet.meta.size.h,
      texture: this.createTexture(require('@/assets/sprites/one-eye.png'))
    }); 
    this.oneeye_mc.position.x = -100;
    this.oneeye_mc.position.y = -2; 
    this.oneeye_mc.position.z = -499;
    this.oneeye_mc.scale.x = this.oneeye_mc.scale.y = this.oneeye_mc.scale.z = 0.1;
    this.oneeye_mc.visible = false;
    this.add(this.oneeye_mc); 


    this.twoeye_mc = new MovieClip({
      fps: 8,
      frames: EyeTwoSpritesheet.frames,
      frame_width: 512,
      frame_height: 512,
      spritesheet_width: EyeTwoSpritesheet.meta.size.w,
      spritesheet_height: EyeTwoSpritesheet.meta.size.h,
      texture: this.createTexture(require('@/assets/sprites/two-eye.png'))
    }); 
    this.twoeye_mc.position.x = -63;
    this.twoeye_mc.position.y = 74; 
    this.twoeye_mc.position.z = -497;
    this.twoeye_mc.scale.x = this.twoeye_mc.scale.y = this.twoeye_mc.scale.z = 0.13;
    this.twoeye_mc.visible = false;
    this.add(this.twoeye_mc); 

    this.three_eye_mc = new MovieClip({
      fps: 8,
      frames: EyeThreeSpritesheet.frames,
      frame_width: 512,
      frame_height: 512,
      spritesheet_width: EyeThreeSpritesheet.meta.size.w,
      spritesheet_height: EyeThreeSpritesheet.meta.size.h,
      texture: this.createTexture(require('@/assets/sprites/three-eye.png'))
    }); 
    this.three_eye_mc.position.x = -18;
    this.three_eye_mc.position.y = 15; 
    this.three_eye_mc.position.z = -498;
    this.three_eye_mc.scale.x = this.three_eye_mc.scale.y = this.three_eye_mc.scale.z = 0.1;
    this.three_eye_mc.visible = false;
    this.add(this.three_eye_mc); 


    this.butterfly_tg = {
      x: 0,
      y: 0,
      z: 0,
      original: {
        x: 50,
        y: -50,
        z: -500
      },
      count: 0
    }
    this.butterfly_mc = new MovieClip({
      fps: 8,
      frames: ButterflySpritesheet.frames,
      frame_width: 512,
      frame_height: 512,
      spritesheet_width: ButterflySpritesheet.meta.size.w,
      spritesheet_height: ButterflySpritesheet.meta.size.h,
      texture: this.createTexture(require('@/assets/sprites/butterfly.png'))
    }); 
    this.butterfly_mc.position.x = this.butterfly_tg.original.x;
    this.butterfly_mc.position.y = this.butterfly_tg.original.y; 
    this.butterfly_mc.position.z = this.butterfly_tg.original.z;
    this.butterfly_mc.scale.x = this.butterfly_mc.scale.y = this.butterfly_mc.scale.z = 0.12;
    //this.butterfly_mc.visible = false;
    this.add(this.butterfly_mc);
  }

  enter() {
    this.butterfly_mc.play(); 

    let delayOne = (3 + (Math.random() * 3));
    TweenMax.delayedCall(delayOne, this.playOne, [0, 2, 'in']);

    let delayTwo = (10 + (Math.random() * 3));
    TweenMax.delayedCall(delayTwo, this.playTwo, [0, 2, 'in']);

    let delayThree = (5 + (Math.random() * 5));
    TweenMax.delayedCall(delayThree, this.playThree, [0, 2, 'in']);

  }

  leave() {
    this.butterfly_mc.gotoAndStop(0); 
    TweenMax.killTweensOf([this.playOne, this.playTwo, this.playThree])
  }

  resize() {  }

  playOne = (startFrame, endFrame, dir) => { 
    if(dir === 'in'){
      this.oneeye_mc.visible = true; 
      this.oneeye_mc.gotoAndPlayRange(startFrame, endFrame, () => { 
        let delay = (1 + Math.random());
        TweenMax.delayedCall(delay, this.playOne, [2, 0, 'out']);
      });
    } else {
      this.oneeye_mc.gotoAndPlayRange(startFrame, endFrame, () => { 
        this.oneeye_mc.visible = false; 
        let delay = (10 + (Math.random() * 3));
        TweenMax.delayedCall(delay, this.playOne, [0, 2, 'in']);
      });
    } 
  }

  playTwo = (startFrame, endFrame, dir) => { 
    if(dir === 'in'){
      this.twoeye_mc.visible = true; 
      this.twoeye_mc.gotoAndPlayRange(startFrame, endFrame, () => { 
        let delay = (  Math.random());
        TweenMax.delayedCall(delay, this.playTwo, [2, 0, 'out']);
      });
    } else {
      this.twoeye_mc.gotoAndPlayRange(startFrame, endFrame, () => { 
        this.twoeye_mc.visible = false; 
        let delay = (10 + (Math.random() * 3));
        TweenMax.delayedCall(delay, this.playTwo, [0, 2, 'in']);
      });
    }
  }

  playThree = (startFrame, endFrame, dir) => { 
    if(dir === 'in'){
      this.three_eye_mc.visible = true; 
      this.three_eye_mc.gotoAndPlayRange(startFrame, endFrame, () => { 
        let delay = (2 + Math.random());
        TweenMax.delayedCall(delay, this.playThree, [2, 0, 'out']);
      });
    } else {
      this.three_eye_mc.gotoAndPlayRange(startFrame, endFrame, () => { 
        this.three_eye_mc.visible = false; 
        let delay = (10 + Math.random() * 5);
        TweenMax.delayedCall(delay, this.playThree, [0, 2, 'in']);
      });
    }
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  onTick = () => {

    this.butterfly_tg.count += (0.01 +  Math.abs(Math.cos(this.butterfly_tg.count))  * 0.02 );

    this.butterfly_tg.x = this.butterfly_tg.original.x + (Math.sin(this.butterfly_tg.count * Math.abs(Math.cos(this.butterfly_tg.count * 0.01)) ) * Math.cos(this.butterfly_tg.count) * 10) ;
    this.butterfly_tg.y = this.butterfly_tg.original.y + (Math.cos(this.butterfly_tg.count) * (2 + (10 * Math.abs(Math.cos(this.butterfly_tg.count * 0.01))) )) ;
    this.butterfly_tg.z = this.butterfly_tg.original.z + (Math.sin(this.butterfly_tg.count) * 10);

    TweenMax.set(this.butterfly_mc.position, {
      y: this.butterfly_tg.y,
      x: this.butterfly_tg.x,
      z: this.butterfly_tg.z + 100
    }) 
  }

  updateRoute(val) { 
    if(val.name === 'intro'){
      this.enter();
    } else {
      this.leave();
    }
  }
 
 
}

export default Eyes